import { useAppSelector, useAppDispatch } from "./useStore";
import { logout as logoutAction } from "../store/slices/authSlice";
import { User } from "../types";

export const useAuth = () => {
  const dispatch = useAppDispatch();
  const auth = useAppSelector((state) => state.auth);

  const hasRole = (roles: string | string[]) => {
    if (!auth.user) return false;
    const userRole = auth.user.role;

    if (Array.isArray(roles)) {
      return roles.includes(userRole);
    }

    return userRole === roles;
  };

  const logout = async () => {
    await dispatch(logoutAction());
  };

  function getUserFromStorage(): User | null {
    const userStr = localStorage.getItem("user");
    if (!userStr) return null;

    try {
      return JSON.parse(userStr) as User;
    } catch {
      return null;
    }
  }

  const user = getUserFromStorage();
  const token = localStorage.getItem("token");

  return {
    ...auth,
    hasRole,
    logout,
    isAuthenticated: !!user && !!token,
  };
};
